import { mapMutations } from 'vuex';
import { PublicClientApplication } from '@azure/msal-browser';

// let tokenResponse;
export default {
  accessTokenResponse: '',
  checkUserResult: ' ',
  checkOwnerResult: '',
  initialUserResult: ' ',
  savedInput: '',
  profilePic: '',
  isAccepted: false,
  isReceiveNews: false,
  recieveNewsStatus: false,
  checkaccessTokenStatus: false,
  actionError: '',
  actionErrorMessage: '',
  ...mapMutations(['setAccessToken']),
  async getAccessToken(msalConfig){
    console.log("getAccessToken");
    let request = {
      scopes: ["openid","https://SiliconCraftTechnologyB2C.onmicrosoft.com/c1e2fec9-07eb-473a-9b55-f59302364f08/Customer.ReadWrite"],
    };
    const msalInstance = new PublicClientApplication(
      msalConfig,
    );
    const accessTokenRequest = {
      request,
      account: msalInstance.getActiveAccount,
      scopes: ["https://SiliconCraftTechnologyB2C.onmicrosoft.com/c1e2fec9-07eb-473a-9b55-f59302364f08/Customer.ReadWrite"],
    }
    let accessToken = "";
    let tokenStatus = false;
    try {
      await msalInstance.acquireTokenSilent(accessTokenRequest).then(
      function (tokenResponse) {
        accessToken = tokenResponse.accessToken;
        console.log(accessToken);
        tokenStatus = true;
      }).catch(function (error) {
        tokenStatus = false;
        this.actionError = "Get Accesstoken from acquireTokenSilent Failed."
        console.error(error);
      });
      
    } catch (error) {
      await msalInstance.acquireTokenPopup(request).then(
        function (tokenResponse) {
          console.log(`Access token acquired via interactive auth ${tokenResponse.accessToken}`)
          accessToken = tokenResponse.accessToken;
          tokenStatus = true;
        }).catch(function (error) {
          tokenStatus = false;
          this.actionError = "Get Accesstoken from acquireTokenPopup Failed."
          console.error(error);
        });
    }
    this.checkaccessTokenStatus = tokenStatus;
    this.accessTokenResponse = accessToken;
  },
  async checkUser(cipherText)
  {
    var response;
    console.log("checkuser");
    var full_api_url = "https://namecard-souvenir-api.azurewebsites.net/api/CheckUser"
    var myHeaders = new Headers();
    const sic43nt =
      JSON.stringify({
        "sic43nt": cipherText
      });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: sic43nt
    };
    try {
      response = await fetch(full_api_url, requestOptions);
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error(Error(errorMessage));
        this.actionError = "Verification responses failed."
      }
      else
      {
        this.checkUserResult = await response.json().catch(error => {console.log('error', error); return false;});   
        console.log(this.checkUserResult);
      }
    } catch (error) {
      response = null;
      console.error(Error(error));
      this.actionError = "The API for verification failed to fetch the data."
    }
    
    return response;
  },
  async checkOwner(token, cipherText) {
    console.log("checkowner");
    var response;
    var myHeaders = new Headers();
    const bearer = `Bearer ${token}`;
    myHeaders.append("Authorization", bearer);
    var full_api_url = "https://namecard-souvenir-api.azurewebsites.net/api/CheckOwner"
    const sic43nt =
      JSON.stringify({
        "sic43nt": cipherText,
      });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: sic43nt
    };
    try {
      response = await fetch(full_api_url, requestOptions);
      console.log(response);
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error(Error(errorMessage));
        this.actionError = "Card owner response failed or token code is wrong."
      }
      else
      {
        this.checkOwnerResult = await response.json().catch(error => {console.log('error', error); return false;});   
      }
    } catch (error) {
      response = null;
      console.error(Error(error));
      this.actionError = "The API for card owner failed to fetch the data."
    }
    
    return response;
  },
  async readUser(token, cipherText) {
    console.log("readUser");   
    var response;
    const myHeaders = new Headers();
    const bearer = `Bearer ${token}`;
    myHeaders.append("Authorization", bearer);
    var full_api_url = "https://namecard-souvenir-api.azurewebsites.net/api/ReadUser"
    const sic43nt =
      JSON.stringify({
        "sic43nt": cipherText
      });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: sic43nt,
    };
    try {
      response = await fetch(full_api_url, requestOptions);
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error(Error(errorMessage));
        this.actionError = "User profile response failed or token code is wrong."
      }
      else
      {
        this.initialUserResult = await response.json().catch(error => {console.log('error', error); return false;}); 
      }
    } catch (error) {
      response = null;
      console.error(Error(error));
      this.actionError = "The API for retrieving user profile failed to fetch the data."
    }
    
    return response;
  },
  async saveProfile(token) {
    console.log("saveProfile");   
    var textCardStatus = false;
    var imgCardStatus = false
    var saveUserStatus = false;
    const headers = new Headers();
    var response;
    const bearer = `Bearer ${token}`;
    headers.append("Authorization", bearer);

    const fetchOptions = {
      method: "POST",
      headers: headers,
      body: this.savedInput,
    };

    console.log(this.savedInput);

    try {
      response = await fetch("https://namecard-souvenir-api.azurewebsites.net/api/UpdateUser", fetchOptions);
      if (!response.ok) {
        textCardStatus = false;
        const errorMessage = await response.text();
        console.error(Error(errorMessage));
        this.actionError = "Profile save failed."
      }
      else
      {
        textCardStatus = true;
        if ((this.profilePic != null) || (this.profilePic != ""))
        {
          let formData = new FormData();
          formData.append('profilePic', this.profilePic);
          try {
            const responseImg = await fetch("https://namecard-souvenir-api.azurewebsites.net/api/UploadProfilePicture", {               
              method: 'POST',
              headers: {
                'Authorization': 'Bearer '+ token,
                'Accept': 'application/json'
              },
              body: formData
            } )       
            
            if(responseImg.ok) {
              imgCardStatus = true;
            }
            else
            {
              imgCardStatus = false;
            }
          } catch (error) {
            imgCardStatus = false;
          }
        }
        else
        {
          imgCardStatus = true;
        }

        if(imgCardStatus && textCardStatus)
        {
          saveUserStatus = true;
        }
        else
        {
          saveUserStatus = false;
        }
      }
    } catch (error) {
      response = null;
      console.error(Error(error)); 
      this.actionError = "The API for saving the profile failed to fetch the data."
    }
    
    return saveUserStatus;
  },
}
